import { useMapEvents } from "react-leaflet";
import { useDispatch } from "react-redux";

import features from "features";

import styles from "./map-vehicle-builder.module.scss";

const MapVehicleBuilder = () => {
  const dispatch = useDispatch();

  const MapClickHandler = () => {
    useMapEvents({
      click: (event) => {
        const { lat, lng } = event.latlng;

        dispatch(
          features.missionsManager.actions.setVehiclePosition({
            coordinates: [lat, lng],
            type: "Point"
          })
        );
      }
    });

    return null;
  };

  return (
    <div className={styles["polygon-builder"]}>
      <MapClickHandler />
    </div>
  );
};

export default MapVehicleBuilder;
